import { useContext } from 'react'

import { ParametrizationMinimumBillingContext } from '@provider/Parametrization/MinimumBilling'

import type { IParametrizationMinimumBillingContext } from '@base/@types/providers/Parametrization/MinimumBillingProvider'

export default function useParametrizationMinimumBilling(): IParametrizationMinimumBillingContext {
  const context = useContext(ParametrizationMinimumBillingContext)

  return context
}
